import { getBenefits } from 'core/controllerPlans/getBenefits'
import getPlanTypeKey from 'core/controllerPlans/getPlanTypeKey'

interface ComparePlan extends CorePlan {
  planTypeKey: string
  benefits: string[]
}

function addPlanAdditionalProperties<T extends CorePlan>(plans: T[]): ComparePlan {
  return Object.keys(plans)
    .map(planId => {
      const plan = plans[planId]
      return {
        ...plan,
        planTypeKey: getPlanTypeKey(plan),
        benefits: getBenefits(plan)
      }
    })
    .reduce((acc, x) => ({ ...acc, [x.planId]: x }), {})
}

export default addPlanAdditionalProperties
